import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWarning24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M11 14V8.5h2V14zM11 17.5v-2h2v2z" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M10.256 3.61 2.17 18.021C1.423 19.354 2.387 21 3.915 21h16.17c1.528 0 2.492-1.645 1.744-2.979L13.744 3.61c-.764-1.362-2.724-1.362-3.488 0M3.916 19 12 4.588 20.085 19z",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconWarning24);
export default ForwardRef;
